<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="ratings"
      :pagination.sync="pagination"
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td style="width: 5%">
            <a
              href="#"
              v-on:click.stop="goToBooking(props.item.booking_id)"
            >{{ props.item.booking_id }}</a>
          </td>
          <td>
            <a
              href="#"
              v-on:click.stop="goToUser(props.item.customer_id)"
            >{{ props.item.customer_name }}</a>
          </td>
          <td>
            <a
              href="#"
              v-on:click.stop="goToDriver(props.item.driver_id)"
              v-html="'<span><b>' + props.item.driver_id + '</b> ' + props.item.driver_name + '</span>'"
            ></a>
          </td>
          <td style="width: 30%">{{ props.item.description }}</td>
          <td>
            <v-rating dense small v-model="props.item.rating" readonly></v-rating>
          </td>
          <td>{{props.item.timestamp}}</td>
          <td style="width: 4%">
            <p v-if="props.item.lateness">{{props.item.lateness}}</p>
          </td>
          <td>
            <v-btn
              @click="revoke(props.item)"
              class="text-none"
              x-small
              flat
            >{{ props.item.revoked ? 'Reinstate' : 'Revoke' }}</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "rating_summary_list",
  components: {},
  props: {
    ratings: Array,
    paginationProp: Object
  },
  data: function() {
    return {
      dialog: Object,
      pagination: this.paginationProp,
      headers: [
        {
          text: "Booking",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Customer",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "pax"
        },
        {
          text: "Content",
          align: "left",
          sortable: false,
          value: "pickup_time"
        },
        {
          text: "Rating",
          align: "left",
          sortable: false,
          value: "pickup"
        },
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "destinations"
        },
        {
          text: "Lateness",
          align: "left",
          sortable: false,
          value: "destinations"
        },
        {
          text: "Revoke",
          align: "left",
          sortable: false,
          value: "driver"
        }
      ]
    };
  },
  methods: {
    revoke(review) {
      console.log("Revoke called");
      console.log(review);

      var url = `${this.$store.state.apiUrl}/review/revoke?id=${review.review_id}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            review.revoked = !review.revoked;
          } else {
            alert("Failed to revoke/reinstate review");
          }
        })
        .catch(function(err) {
          console.error(err);
        });
    },
    goToBooking: function(bookingID) {
      let routeData = this.$router.resolve({
        path: "/bookings",
        query: { bookingID: bookingID }
      });
      window.open(routeData.href, "_blank");
    },
    goToUser: function(id) {
      window.open(`/customer/view/${id}`, "_blank");
    },
    goToDriver: function(id) {
      window.open(`/driver/view/${id}`, "_blank");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
